import {
  Component,
  Input,
  ViewChild,
  OnInit,
  Output,
  EventEmitter
} from '@angular/core';
import { ImageResult, ResizeOptions } from 'ng2-imageupload';

@Component({
  selector: 'photo-question',
  templateUrl: './photo-question.component.html',
  styleUrls: ['./photo-question.component.less']
})
export class PhotoQuestionComponent implements OnInit {
  @Input() question: any;
  @ViewChild('imageInputField') imageInput: any;
  @Output() answered: EventEmitter<any> = new EventEmitter();
  @Output() answerCleared: EventEmitter<any> = new EventEmitter();
  @Output() modified: EventEmitter<any> = new EventEmitter();
  hasAnswer: Boolean = false;
  image: string = '';
  resizeOptions: ResizeOptions = {
    resizeMaxHeight: 980,
    resizeMaxWidth: 980
  };

  ngOnInit() {
    if (this.question.rows[0].value) {
      this.hasAnswer = true;
      this.image = this.question.rows[0].value;
    }
  }

  selected(imageResult: ImageResult) {
    this.image = imageResult.resized
                 && imageResult.resized.dataURL
                 || imageResult.dataURL;
    this.question.rows[0].value = this.image;

    if (!this.hasAnswer) {
      this.hasAnswer = true;
      this.answered.emit(null);
    }

    this.modified.emit(null);
  }

  clear() {
    this.image = '';
    this.question.rows[0].value = '';
    this.imageInput.nativeElement.value = '';

    if (this.hasAnswer) {
      this.hasAnswer = false;
      this.answerCleared.emit(null);
    }

    this.modified.emit(null);
  }
}



// WEBPACK FOOTER //
// ./src/app/survey/photo-question/photo-question.component.ts